var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.8215;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#D2D2D2;}\n\t.st3{fill:#CFCFCF;}\n\t.st4{fill:none;stroke:#BABABA;stroke-width:2.8215;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.2,78.9c-21.5,0-43.3-0.9-63.8-6.5C132,66.7,114.1,56,97.5,43.5C86.8,35.3,77,28.9,63.1,29.8 c-13.6,0.7-26.7,5.8-37.2,14.5c-17.9,15.5-15,44.3-8,64.5c10.7,30.5,43.1,51.6,70.7,65.4c31.9,15.9,66.9,25.2,102,30.5 c31,4.7,70.3,8.1,97-12c24.5-18.5,31.2-60.6,25.2-89.1c-1.5-8.4-5.9-16-12.6-21.4c-17.2-12.6-42.9-4.2-62.2-3.8 C230.9,78.7,223.5,78.9,216.2,78.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.5,108.5l233.2-40.7l15.5,88.8c0.5,2.6-0.1,5.3-1.7,7.5c-1.5,2.2-3.9,3.7-6.5,4.1L68.6,205.5 c-2.6,0.5-5.3-0.1-7.5-1.7c-2.2-1.5-3.7-3.9-4.1-6.5L41.5,108.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.6,68l-231,40.3l3.3,19.1l231-40.4L273.6,68z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.3,91.8l41.7-7.3l9,51.6c0.3,1.6-0.1,3.2-1,4.5c-0.9,1.3-2.3,2.1-3.8,2.4l-30,5.2c-1.6,0.3-3.2-0.1-4.4-1 c-1.3-0.9-2.2-2.3-2.4-3.9L137.3,91.8L137.3,91.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.2,52.9l174.2-30.4c7.8-1.4,15.9,0.5,22.4,5c6.5,4.6,10.9,11.5,12.3,19.4l3.7,20.9L41.5,108.5l-3.7-20.9 c-1.4-7.8,0.4-15.9,5-22.4C47.4,58.7,54.4,54.3,62.2,52.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.5,106.9c0.3,1.7,0.1,3.4-0.5,4.9c-0.6,1.6-1.7,3-3,4l1.8,9.9c0.1,0.6,0.1,1.1,0,1.7 c-0.1,0.6-0.4,1.1-0.7,1.5c-0.3,0.5-0.7,0.8-1.2,1.2c-0.5,0.3-1,0.5-1.6,0.6c-0.6,0.1-1.1,0.1-1.7,0c-0.5-0.1-1.1-0.3-1.5-0.6 c-0.5-0.3-0.9-0.7-1.2-1.2c-0.3-0.5-0.5-1-0.6-1.6l-1.7-9.9c-1.6-0.5-3-1.5-4.1-2.7c-1.1-1.3-1.9-2.8-2.1-4.5 c-0.4-2.4,0.1-4.9,1.5-6.9c1.4-2,3.5-3.4,5.9-3.8c2.4-0.4,4.9,0.1,6.9,1.6C168.6,102.4,170,104.5,170.5,106.9L170.5,106.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.8,32c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5C144.3,30.8,145.4,32,146.8,32z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.3,29.3c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5C24.8,28.1,25.9,29.3,27.3,29.3 z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.9,177.7c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5 C28.4,176.5,29.6,177.7,30.9,177.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M115.9,9v11.1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.4,14.6h11"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M131,209.5v11"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M125.5,215h11"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M301.5,38.2v11.1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M296,43.8h11"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.7,254.7c52,0,94.2-2.6,94.2-5.9s-42.2-5.9-94.2-5.9c-52,0-94.2,2.6-94.2,5.9S111.7,254.7,163.7,254.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccess);
export default __webpack_public_path__ + "static/media/no-access.f57eb3eab25736fdc776834fc5b4dcb1.svg";
export { ForwardRef as ReactComponent };